import { render, staticRenderFns } from "./HubFacebookPageModal.vue?vue&type=template&id=0513daed&scoped=true&"
import script from "./HubFacebookPageModal.vue?vue&type=script&lang=js&"
export * from "./HubFacebookPageModal.vue?vue&type=script&lang=js&"
import style0 from "./HubFacebookPageModal.vue?vue&type=style&index=0&id=0513daed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0513daed",
  null
  
)

export default component.exports